import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { get_Pooja_Data, get_Pooja_Single_Data, } from "../../../store/actions/CommanAction";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";

const PoojaFor = () => {
  const dispatch = useDispatch();
  const PoojaData = useSelector((state) => state.feedBackReducer.PoojaData);
  const PoojaSingleData = useSelector(
    (state) => state.feedBackReducer.PoojaSingleData
  );
  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [PujaForID, setPujaForID] = useState("");
  const [loading, setloading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    PujaFors: "",
    CreatedByUser: "1",
    IsActive: "1",
  });

  const Reset = () => {
    setaddFormData({ ...addFormData, PujaFors: "" });
  };

  useEffect(() => {
    if (PoojaSingleData) {
      setEditValue(PoojaSingleData);
    }
  }, [PoojaSingleData]);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_Pooja_Data("1", setloading));
    } else {
      dispatch(get_Pooja_Data("0", setloading));
    }
  }, [IsActive, IsActive]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,
        PujaForID: PujaForID,
        PujaFors: EditValue[0]?.PujaFors,
        ModifiedByUser: "1",
      });
    }
  }, [EditValue]);

  // const handleAddFormSubmit = async (event) => {
  //   event.preventDefault();
  //   const trimpujafor = addFormData.PujaFors.trim()
  //   let error = false;
  //   let errorMsg = "";
  //   if (!trimpujafor) {
  //     error = true;
  //     errorMsg = "Please fill Pooja.";
  //   }

  //   // if (addFormData.PujaFors === "") {
  //   //   error = true;
  //   //   errorMsg = "Please fill Pooja.";
  //   // }
  //   if (!error) {
  //     const newCustomerStory = {
  //       PujaFors: addFormData.PujaFors,
  //       IsActive: addFormData.IsActive,
  //     };
  //     await AddUpdate("PujaFor/Insert_PujaFor", newCustomerStory);
  //     setPostModal(false);
  //     dispatch(get_Pooja_Data(IsActive, setloading));
  //     swal("Good job!", "Successfully Added", "success");
  //     Reset();
  //     setaddFormData({ PujaFors: "" });
  //   } else {
  //     swal("Oops", errorMsg, "error");
  //   }
  // };


const handleAddFormSubmit = async (event) => {
  event.preventDefault();
  const trimpujafor = addFormData.PujaFors.trim();
  let error = false;
  let errorMsg = "";

  if (!trimpujafor) {
    error = true;
    errorMsg = "Please fill Pooja.";
  }

  if (!error) {
    const newCustomerStory = {
      PujaFors: addFormData.PujaFors,
      IsActive: addFormData.IsActive,
    };

    const res = await AddUpdate("PujaFor/Insert_PujaFor", newCustomerStory);

    try {
      const parsed = JSON.parse(res?.data?.data); 

      const message = parsed?.Table?.[0]?.Message;
      

      if (message === "Not Insert Successfully ") {
        swal("Oops!", "Duplicate entry. Cannot insert same Puja again.", "error");
      } else {
        setPostModal(false);
        dispatch(get_Pooja_Data(IsActive, setloading));
        swal("Good job!", "Successfully Added", "success");
        Reset();
        setaddFormData({ PujaFors: "" });
      }
    } catch (err) {
      console.error("Failed to parse API response:", err);
      swal("Oops!", "Something went wrong while processing the response.", "error");
    }
  } else {
    swal("Oops", errorMsg, "error");
  }
};





  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    if (addFormData.PujaFors === "") {
      error = true;
      errorMsg = "Please fill Pooja.";
    }
    if (!error) {
      await AddUpdate("PujaFor/Update_PujaFor", addFormData);
      setEditModal(false);
      dispatch(get_Pooja_Data(IsActive, setloading));
      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({ PujaFors: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormChange = (e) => {
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {
    dispatch(get_Pooja_Single_Data(row?.PujaForID));
    setPujaForID(row?.PujaForID);
    setEditModal(true);
  };

  const columns = [
    {
      name: "PujaFor",
      selector: (row) => row.PujaFors,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.PujaForID, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "PujaFors",
      selector: (row) => row.PujaFors,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          // style={{ position: "absolute", top: "7px", right: 0 }}
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 50 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.PujaForID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    PujaForID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      PujaForID: PujaForID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate("PujaFor/Delete_PujaFor", postData);
    dispatch(get_Pooja_Data(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="main_card mb-0 ">
          <div>
            <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Puja Categories</h2>
          </div>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="card-action coin-tabs mb-2">
              <Nav as="ul" className="nav nav-tabs" role="tablist">
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="All"
                    onClick={(currentStatus) => {
                      setIsActive(true);
                    }}
                  >
                    Active
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="Inactive"
                    onClick={(currentStatus) => {
                      setIsActive(false);
                    }}
                  >
                    Inactive
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>

            <Link
              to={"#"}
              className="btn btn-primary font-w600 mb-2 "
              onClick={() => {
                setPostModal(true);
                Reset();
              }}
            >
              + New Pooja
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="">
              <div className="p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className=" d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">Add Pooja</h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>


                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <label htmlFor="">Pooja</label>
                                <span className="text-danger star-error">
                                  *
                                </span>
                                <div className="form-group">
                                  <input
                                    type="text"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="PujaFors"
                                    required="required"
                                    value={addFormData?.PujaFors}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">Edit Pooja</h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <label htmlFor="">Pooja</label>
                                  <span className="text-danger star-error">
                                    *
                                  </span>
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      // className="form-control"
                                      autoComplete="off"
                                      name="PujaFors"
                                      required="required"
                                      value={addFormData?.PujaFors}
                                      onChange={handleAddFormChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>

                    <div className="col-12 mt-4 main_card">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={PoojaData}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>


                  <Tab.Pane eventKey="Inactive">
                      <div className="col-12 mt-4 main_card">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={PoojaData}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                            customStyles={customStyles}
                          />
                        )}
                      </div>
                   
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default PoojaFor;
